export const loginApi = async (email, password) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}/sessions`;
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email,
      password
    }),
  };

  const response = await fetch(URL, requestOptions);

  if (response.status === 404) {
    throw new Error('Not found');
  }
  if (response.status === 422) {
    throw new Error('Unprocessable Entity');
  }
  if (response.status === 500) {
    throw new Error('Internal Server Error');
  }

  const jsonResponse = await response.json();

  return jsonResponse;
};

export const logoutApi = async (token) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}/sessions`;
  const requestOptions = {
    method: 'DELETE',
    headers: {
      Authorization: 'Token token=' + token,
    }
  };

  const response = await fetch(URL, requestOptions);

  if (response.status === 422) {
    throw new Error('Unprocessable Entity');
  }
  if (response.status === 500) {
    throw new Error('Internal Server Error');
  }

  const jsonResponse = await response.json();

  return jsonResponse;
};

export const sessionApi = async (token) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}/sessions`;
  const requestOptions = {
    method: 'GET',
    headers: {
      Authorization: 'Token token=' + token,
    }
  };

  const response = await fetch(URL, requestOptions);

  if (response.status === 401) {
    throw new Error('Unauthorized');
  }
  if (response.status === 404) {
    throw new Error('Not found');
  }
  if (response.status === 422) {
    throw new Error('Unprocessable Entity');
  }
  if (response.status === 500) {
    throw new Error('Internal Server Error');
  }

  const jsonResponse = await response.json();

  return jsonResponse;
};

export const signUpApi = async (username, email, password) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}/signup`;
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      username,
      email,
      password
    }),
  };

  const response = await fetch(URL, requestOptions);

  if (response.status === 404) {
    throw new Error('Not found');
  }
  if (response.status === 422) {
    throw new Error('Unprocessable Entity');
  }
  if (response.status === 500) {
    throw new Error('Internal Server Error');
  }

  const jsonResponse = await response.json();

  return jsonResponse;
};